import {CheckOutlined, LoadingOutlined, OrderedListOutlined} from "@ant-design/icons";
import React, {Fragment, useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import {fetchWrapper} from "../../helpers";
import {Button, Modal} from "antd";
import {message as Message} from "antd";
import {ChatContext} from "../Chats/AssistantChat";
import LeadingTextAreaWithMic from "../blocks/LeadingTextAreaWithMic";
import {extractSystemMessage} from "../../helpers/extract-system-message";
import {getFirstNWords} from "../../helpers/get-first-words";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

const GetLeadingQuestionsFromAssistantMessageModal = ({title, message, id, messagesList}) => {
	const [isBusyMic, setIsBusyMic] = useState(false);
	const {setMyMessage, sendMessage} = useContext(ChatContext);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [questions, setQuestions] = useState(undefined);
	const [answers, setAnswers] = useState(undefined);
	const {t} = useTranslation();

	const handleChangeAnswers = (value, index) => {
		setAnswers(prev => ({
			...prev,
			[index]: value
		}));
	};

	const handleOpenModal = () => setIsModalOpen(true);

	const handleGetLeadingQuestions = async () => {
		try {
			setIsLoading(true);
			const response = await fetchWrapper.post(`${baseUrl}/content-plan/leading-questions-topic`, {
				description: message
			});
			await setQuestions(response?.questions || '');
			setIsLoading(false);
			setIsModalOpen(true);
			const resQuestions = response?.questions?.split('\n');
			resQuestions.forEach((item, index) => {
				(/^\d/.test(item.trim()) && handleChangeAnswers('', index));
			});
			Message.success(t("functions.successfullyGenerated"));
		} catch (err) {
			console.error(err);
			setIsLoading(false);
		}
	};

	const handleMoveQuestionsToChatMessage = () => {
		setIsModalOpen(false);
		try {
			const movedQuestions = questions.split('\n\n').filter((item) => /^\d/.test(item.trim())).join('\n\n');
			setMyMessage(prev => prev ? prev + '\n\n' + movedQuestions : movedQuestions);
			Message.success(t("functions.successfullyMoved"));
		} catch (err) {
			console.error(err);
		}
	};

	const handleMoveAnswersToChatMessage = () => {
		setIsModalOpen(false);
		try {
			answers && Object.keys(answers).forEach((key, index) => {
				const answer = answers[key] || '-';
				setMyMessage(prev => prev ? `${prev}\n\n${index+1}. ${answer}` : `${index+1}. ${answer}`);
			});
			Message.success(t("functions.successfullyMoved"));
		} catch (err) {
			console.error(err);
		}

	};

	const handleSendAnswersPrompt = () => {
		const postContext = `${message?.replace('\n', ' ')?.slice(0, 150)}...`;
		const myQuestions = questions?.split('\n\n')?.filter((item) => /^\d/.test(item.trim()))?.join('\n\n')?.split('\n').filter((item) => item.trim() !== '');
		// console.log('myQuestions', myQuestions);
		setIsModalOpen(false);
		let sys_answers = '';
		let prompt = '';
		let qa_prompt_part = '';
		let qIndex = 1;
		try {
			answers && Object.keys(answers).forEach((key, index) => {
				const question = myQuestions[index]?.replace(/\d+\. /, '');
				const answer = answers[key] || '-';
				if (answer !== '-'){
					sys_answers += qIndex > 1 ? `\n\n${t('assistant.answerWithNumber', { count: qIndex, answer })}` : t('assistant.answerWithNumber', { count: qIndex, answer });
					// "Question {{count}}: \"{{question}}\"\nand the user’s answer: \"{{answer}}\"\n\n"
					qa_prompt_part += `Question ${qIndex}: "${question}"\nAnswer ${qIndex}: "${answer}"\n\n`;
					// prompt += t('assistant.leadingQAPrompt1', {count: qIndex, question, answer});
					qIndex++;
				};
				// prompt += `Вопрос ${index+1} «${question}»\nи ответ пользователя: «${answer}»\n\n`;
			});
			Message.success(t("functions.successfullyMoved"));
		} catch (err) {
			console.error(err);
		}
		const sys_info = {
			type: 'request_for_editing_post_with_info',
			postCount: id,
			message: sys_answers,
		};

		const change_post_prompt = (postNumber) => `change only this post #${postNumber} with the user's response to the leading questions to improve this post:`;
		let context_prompt_part = 'I will list POST SERIES WHICH INLCUDES posts in the following order:\n';
		messagesList?.forEach((item, index) => {
			if (item?.type === 'post' && item?.id === id){
				context_prompt_part += `Post #${item?.id || index+1}: "${item?.content}"\n${change_post_prompt(item?.id || index+1)?.toUpperCase()}\n${qa_prompt_part}\n\n`;
			} else {
				if (item?.type === 'post'){
					context_prompt_part += `Post #${item?.id || index+1}: "${item?.content}"\n\n`;
				}
			}
		});
		const system_part_prompt = `@[[[SYSTEM_MESSAGE(\'${JSON.stringify(sys_info)}\')]]]@ \n\n`;
		// const body_prompt_part = `ALTER ONLY Post #${id}.\n${qa_prompt_part}\n`;
		const body_prompt_part = ``;
		prompt = `${system_part_prompt}${context_prompt_part}${body_prompt_part}DO NOT MODIFY OTHER POSTS IN THIS SERIES. Please PROVIDE ALL POSTS in your response in JSON format.`;
		// prompt = `Внеси дополнения в пост №${id} с учетом ответа пользователя на вспомогательные вопросы по теме поста:\n${prompt}\nОстальные посты из этих постов не меняй, предоставь в ответе все посты`;
		// console.log(prompt);
		// console.log(sys_info.message);
		// console.log(JSON.parse(extractSystemMessage(prompt)));
		sendMessage({my_msg:prompt, returnMyMessage: true, forceISearching: false});
	};

	return (
			<div className='flex items-center gap-2 ml-auto'>
				<button
					disabled={isLoading}
					onClick={questions? handleOpenModal : handleGetLeadingQuestions}
					className='flex items-center text-left text-nowrap logout-button !w-auto !h-auto !py-1 !px-1.5 !text-xs !text-white !m-0'
				>
					{isLoading ? (
							<>
								<LoadingOutlined className='mr-1' />
								{t('assistant.waitLeadingQuestions')}...
							</>
					):(
							questions? (
								<>
									<CheckOutlined className='mr-1' />
									{t('assistant.seeLeadingQuestions')}
								</>
							):(
								<>
									<OrderedListOutlined className='mr-1' />
									{t('assistant.getLeadingQuestions')}
								</>
							)
					)}
				</button>

				<Modal
						open={isModalOpen}
						title={title || ''}
						onOk={handleSendAnswersPrompt}
						onCancel={isBusyMic? null : ()=>setIsModalOpen(false)}
						footer={[
							<button className='my-1 logout-button' disabled={!answers || isBusyMic} key="submitAnswers" onClick={handleSendAnswersPrompt}>
								{t('assistant.reviseAnswer')}
							</button>,
							// <Button className='my-1' disabled={!answers} key="submitAnswers" type="primary" onClick={handleMoveAnswersToChatMessage}>
							// 	{t('assistant.moveLeadingAnswersToChatMessage')}
							// </Button>,
							// <Button className='my-1' key="submitQuestions" type="primary" onClick={handleMoveQuestionsToChatMessage}>
							// 	{t('assistant.moveLeadingQuestionsToChatMessage')}
							// </Button>,
							// <Button className='my-1' key="back" onClick={()=>setIsModalOpen(false)}>
							// 	{t('functions.close')}
							// </Button>,
						]}
				>
					{questions && (
					<pre className='block text-wrap text-pretty max-w-full font-inherit text-inherit'>
						{questions?.split('\n')?.map((item, index) => (
							(/^\d/.test(item.trim())?(
								<Fragment key={index}>
									<br/>
									<label
										className='block font-medium w-full !text-xs mb-1'
										htmlFor={`qa-${index}`}
									>
										{item}
									</label>
									<LeadingTextAreaWithMic
											post={message}
											value={answers[index]}
											index={index}
											question={item}
											isBusyMic={isBusyMic}
											setIsBusyMic={setIsBusyMic}
											handleChangeAnswers={handleChangeAnswers}
									/>
								</Fragment>
							): (
								<p key={index} className='w-full text-xs'>
									{item}
								</p>
							)
						)))}
					</pre>
					)}
				</Modal>
			</div>
	);
};

export default GetLeadingQuestionsFromAssistantMessageModal;